import { EnumDefinition } from '../classes/enum-definition';

export const USER_SCOPES: EnumDefinition = {
    id: 'scopes',
    items: [
        {label: 'ScopesUser', data: 'USER'},
        {label: 'ScopesAdmin', data: 'ADMIN'}
    ]
};
